var React = require('react');

function IcnSuccess (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"SuccessIcon","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"fill":"#00D2DC","fillRule":"nonzero","id":"Combined-Shape"},React.createElement("path",{"d":"M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M6.5,9.08578644 L5.20710678,7.79289322 C4.81658249,7.40236893 4.18341751,7.40236893 3.79289322,7.79289322 C3.40236893,8.18341751 3.40236893,8.81658249 3.79289322,9.20710678 L5.79289322,11.2071068 C6.18341751,11.5976311 6.81658249,11.5976311 7.20710678,11.2071068 L12.2071068,6.20710678 C12.5976311,5.81658249 12.5976311,5.18341751 12.2071068,4.79289322 C11.8165825,4.40236893 11.1834175,4.40236893 10.7928932,4.79289322 L6.5,9.08578644 Z"})))]);
}

IcnSuccess.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = IcnSuccess;

IcnSuccess.default = IcnSuccess;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/images/icn-success.svg
// module id = 439
// module chunks = 0